<template>
  <div class="box11">
    <pageTitle
      title="多项职业发展路径&nbsp;&nbsp;更具职场竞争力"
      text="C/C++是目前唯一适应多方面需求的编程语言"
    />
    <div class="title">职业路径</div>

    <div class="content">
      <div class="demo" v-for="(item, index) in list" :key="index">
        <div class="point" v-for="i in item.point" :key="i" v-html="i"></div>
        <div class="text" v-html="item.text"></div>
      </div>
    </div>

    <div class="tag">
      C/C++软件开发工程师
      <div class="block">博学谷毕业学生起点</div>
    </div>

    <div class="title">适学人群</div>

    <div class="content2">
      <div class="demo" v-for="(item, index) in content" :key="index">
        <div class="icon">
          <img
            :src="
              require(`../../../assets/coursePage/cPuls/box11/icon${
                index + 1
              }.png`)
            "
            alt
          />
        </div>
        <div class="tit" v-html="item.title"></div>
        <div class="text" v-html="item.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },

  data() {
    return {
      list: [
        {
          point: [
            "技术CTO",
            "项目负责人",
            "Linux服务器<br />开发工程师",
            "桌面开发<br />工程师",
          ],
          text: "游戏服务器<br />开发方向",
        },
        {
          point: [
            "大数据/云计算<br />工程师",
            "Web架构<br />工程师",
            "微服务分布式<br />开发工程师",
            "Web服务器<br />开发工程师",
          ],
          text: "Windows<br />项目方向",
        },
        {
          point: [
            "技术总监",
            "系统架构师",
            "微服务开发<br />工程师",
            "Go后端服务器<br />工程师",
          ],
          text: "Go语言分布式<br />服务器方向",
        },
      ],
      content: [
        {
          title: "零基础小白<br />对编程有浓厚兴趣",
          text: "今后想要一直从事编程工<br />作，学好C++为后续工作<br />打下坚实基础",
        },
        {
          title: "有编程基础<br />但知识体系不完整",
          text: "有一定开发经验，但计算<br />机知识体系掌握不完整，<br />希望更深入掌握",
        },
        {
          title: "喜欢挑战<br />具有极客精神学员",
          text: "拒绝“平庸”，喜欢不断向<br />上超越自我，自信且执着<br />的学员",
        },
        {
          title: "对网络安全<br/>感兴趣学员",
          text: "后续想从事逆向破解或者<br />网络攻防技术相关工作",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box11 {
  padding-top: 80px;
  padding-bottom: 88px;
  width: 100%;
  background-image: linear-gradient(
    97deg,
    rgba(0, 127, 255, 0.06) 0%,
    rgba(0, 170, 255, 0.06) 100%
  );

  .title {
    margin-top: 48px;
    margin-bottom: 48px;
    font-size: 36px;
    text-align: center;
    font-weight: bold;
    color: #191c47;
  }

  .content {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 690px;
    .demo {
      .point {
        position: relative;
        margin-bottom: 58px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 110px;
        background-color: #ffffff;
        box-shadow: 0px 4px 24px 0px rgba(0, 163, 251, 0.26);
        border-radius: 12px;
        font-family: PingFang SC;
        font-size: 24px;

        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #000000;
        &::after {
          position: absolute;
          left: 50%;
          bottom: -38px;
          transform: translate(-50%, 0px);
          content: "";
          width: 18px;
          height: 18px;
          background: url("../../../assets/coursePage/cPuls/box11/icon.png")
            no-repeat;
          background-size: contain;
        }
      }
      .text {
        position: relative;
        top: -5px;
        font-family: PingFangSC-Semibold;
        font-size: 24px;
        font-weight: bold;
        font-stretch: normal;
        text-align: center;
        line-height: 40px;
        letter-spacing: 0px;
        color: #317cff;
        &::after {
          position: absolute;
          left: 50%;
          bottom: -32px;
          transform: translate(-50%, 0px);
          content: "";
          width: 18px;
          height: 18px;
          background: url("../../../assets/coursePage/cPuls/box11/icon.png")
            no-repeat;
          background-size: contain;
        }
      }
    }
  }

  .tag {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;
    width: 690px;
    height: 87px;
    background-color: #ffffff;
    box-shadow: 0px 4px 24px 0px rgba(0, 163, 251, 0.26);
    font-family: PingFang SC;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;

    letter-spacing: 0px;
    color: #000000;
    border-radius: 12px;
    .block {
      margin-left: 19px;
      padding-left: 10px;
      width: 281px;
      height: 56px;
      background: url("../../../assets/coursePage/cPuls/box11/tag.png")
        no-repeat;
      background-size: cover;
      text-align: center;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;

      line-height: 58px;
      letter-spacing: 0px;
      color: #ffffff;
      box-sizing: border-box;
    }
  }

  .content2 {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
    padding: 50px 40px;
    width: 690px;
    height: 751px;
    background-color: #ffffff;
    box-shadow: 0px 5px 40px 0px rgba(0, 163, 251, 0.2);
    border-radius: 20px;
    box-sizing: border-box;
    background: #ffffff
      url("../../../assets/coursePage/cPuls/box11/content.png") no-repeat;
    background-size: 612px 662px;
    background-position: center;
    .line {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, 0px);
      width: 610px;
      height: 1px;
      background-color: #e9f8ff;
      background-color: red;
      opacity: 1;
    }

    .line2 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(0px, -50%);
      width: 1px;
      height: 657px;
      background-color: #e9f8ff;
      background-color: red;
      opacity: 1;
    }
    .demo {
      text-align: left;
      margin-bottom: 50px;
      .icon {
        margin-bottom: 25px;
        width: 62px;
        height: 62px;
        background-color: #e0f5ff;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .tit {
        margin-bottom: 15px;
        font-family: PingFangSC-Semibold;
        font-size: 26px;
        font-weight: bold;
        text-align: left;
        line-height: 42px;
        color: #0080ff;
      }
      .text {
        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #002233;
      }
    }
  }
}
</style>
